import { render } from "./DocumentsBlock.vue?vue&type=template&id=4ec48a96"
import script from "./DocumentsBlock.vue?vue&type=script&lang=js"
export * from "./DocumentsBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__